import { types } from '@actions/countries';

export const initialState = [];

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.POPULATE_COUNTRIES_LIST:
      return [...action.countries];
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./redux/reducers/countries.js